<template>
	<div>
		<div :class="typeMessage" role="alert" id="message-update" v-if="message != ''">
			{{message}}
		</div>
		<table class="table" id="table-products">
				<thead>
					<tr>
						<th class="smallName;">Producto id</th>
						<th class="smallName;">Contrato id</th>
						<th class="largeName">Nombre</th>
						<th class="xlargeName">Descripción</th>
						<th class="mediumName">Proceso</th>
						<th class="mediumName">Asignaciones</th>
						<th class="mediumName">Precio $</th>
						<th class="mediumName">Guardar</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(contract_product, index) in contract.contracts_products" :key="index">
						<td>{{contract_product.product.id}}</td>
						<td>{{contract.id}}</td>
						<td>{{contract_product.product.name}}</td>
						<td>{{contract_product.product.description}}</td>
						<td>{{contract_product.product | projectType }}</td>
						<td>
							<ul class="list-group list-group-flush">
								<li class="list-group-item item-assignments" v-for="assignment_type in contract_product.product.assignment_types" :key="assignment_type.id">
									{{assignment_type.name}}
								</li>
							</ul>
						</td>
						<td>
							<input type="number" :id="`price${index}`" class="form-control text-nowrap" style="width: 100% !important;" name="quantity" min="1" max="5" v-model="contract_product.price">
						</td>
						<td>
							<button type="button" :id="`update${index}`" class="btn btn-success" @click="updatePrice(index)">Guardar</button>
						</td>
					</tr>				
				</tbody>						
		</table>
	</div>
</template>
<script>
import axios from 'axios';
export default {
	name: 'TableContracts',
	props: ['contract'],
	methods: {
		updatePrice(index){

			var token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
			axios.defaults.headers['x-csrf-token'] = token

			var price = this.contract.contracts_products[index].price
			var productId = this.contract.contracts_products[index].product.id
			var path = '/contracts/' + this.contract.id + '/update_price?product_id=' + productId + '&price=' + price
      axios.put(path).then(res=>{
				if(res.status == 200){
					this.showMessage('Precio actualizado', 'alert-success')
				}else{
					this.showMessage('No se pudo actualizar el precio', 'alert-warning')
				}
      }, (err) => {
				this.showMessage('No se pudo actualizar el precio', 'alert-danger')
			})          			
		},
		showMessage(message, typeMessage){
			this.message = message
			this.typeMessage = typeMessage
			setTimeout(() => this.message = '', 3000)
		}
	},
	data() {
		return {
			message: '',
			typeMessage: ''
		}
	},
	created () {

	},
	components: {

	},
	filters: {
		projectType: function(product) {
			if(product.project_type != null){
				return product.project_type.name
			}else{
				return ""
			}
		}
	}
}
</script>
<style src='./table-products.css'></style>